import { myAxios } from "./axios";

export function getCompanies(data, { page, perPage }) {
  let config = {
    params: {
      page,
      perPage,
      title: data ? data.txt : null,
      ...(data || {})
    },
  };
  return myAxios.get("/companies", config);
}

export function getCompany(id) {
  return myAxios.get("/companies/" + id);
}

export function addCompany(data) {
  return myAxios.post("/companies/create", data);
}

export function editCompany(id, data) {
  return myAxios.put("/companies/" + id + "/update", data);
}

export function deleteCompany(id) {
  return myAxios.delete("/companies/" + id + "/delete");
}

export function importCompanies(data) {
  return myAxios.post("/companies/import", data);
}
